// extracted by mini-css-extract-plugin
export default {"content":"Demo_content__d4dMH","example":"Demo_example__dn05i","exampleWrapper":"Demo_exampleWrapper__hUxsJ","box":"Demo_box__HPHSc","preview":"Demo_preview__KcFWO"};